/* 工程看板团队范围：管理员 / 工程经理 / CEO / 总部 默认「全部团队」；其他层级默认本团队，可切换到其他团队或全部（只读） */
export const isTeamManager = (user) => ["admin", "eng_manager", "ceo"].includes(user?.role) || user?.region === "hq";
/* 所属小组（可多选）：teams[] 优先，回退单值 team */
export const userTeams = (user) => { const ts = (user?.teams || []).filter(Boolean); return ts.length ? ts : (user?.team ? [user.team] : []); };
export const inUserTeam = (user, team) => !!team && userTeams(user).includes(team);
export const defaultTeamFilter = (user) => (isTeamManager(user) || userTeams(user).length !== 1 ? "all" : userTeams(user)[0]);
export const teamFilterKey = (page, user) => `${page}_teamFilter:${user?.username || ""}`;
export const initTeamFilter = (page, user) => localStorage.getItem(teamFilterKey(page, user)) || defaultTeamFilter(user);
/* 是否可操作该项目（推进阶段等）：管理员 / 工程经理 全部；工程组成员 仅本组（可多组，与后端 can_access_project 一致） */
export const canOperateProject = (user, p) => ["admin", "eng_manager", "ceo"].includes(user?.role) || (user?.role === "member" && (!p || inUserTeam(user, p.team)));
/* 是否可编辑项目信息（与后端 can_operate_project 一致）：销售 / 仓库 / 外部账号只读；member / cdc 限本组（HQ 成员全部） */
const PROJECT_WRITE_ROLES = ["admin", "eng_manager", "ceo", "pm", "cdc", "member", "finance"];
/* 协办同事（projects.coStaff）：与主负责人同等可见 / 可操作（与后端 co_staff.is_co_staff 一致） */
export const isCoStaff = (user, p) => {
  if (!user || !p?.coStaff) return false;
  const mine = [user.name, user.nameZh, user.username].filter(Boolean);
  return Object.values(p.coStaff).some((arr) => (arr || []).some((n) => mine.includes(n)));
};
export const canEditProject = (user, p) => {
  if (!user || !PROJECT_WRITE_ROLES.includes(user.role)) return false;
  if (isCoStaff(user, p)) return true;
  if (user.role === "member") return user.region === "hq" || !p || inUserTeam(user, p.team);
  if (user.role === "cdc") return !userTeams(user).length || !p || inUserTeam(user, p.team);
  return true;
};
